/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { CKEditor } from "ckeditor4-react";
import produce from "immer";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import { Button, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { FileUploader } from "../../../components/FileUploader/FileUploader";
import { IInvestigator } from "../../../interfaces/IInvestigator";
import { paths } from "../../../utils/paths";
import Axios from "axios";
import {
  create,
  Delete,
  getAll,
  getById,
  getByInvestigator,
  resetPass,
  saveFile,
  update,
  patch
} from "../../../utils/requests/dynamicReq";
import { validateEmail } from "../../../utils/validate";
import { ROUTES } from "../../../utils/routes";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";
import { IPublication } from "../../../interfaces/IPublication";
import estrella from "../../../assets/images/estrella.svg";
import estrellaAzul from "../../../assets/images/estrellaSolid.svg";
import {
  requiredInputs,
  SwalError,
  editorConfig,
  baseURL,
} from "../../../utils/constants";
import moment from "moment";
import parse from "html-react-parser";

// interface IResearchLineShort {
//   researchLine_id: string;
//   tituloEs: string;
// }

interface IInvestigatorRole {
  staff_role_id: string;
  name: string;
}

interface IUserRole {
  user_role_id: string;
  name: string;
}

interface INewPassword {
  oldPassword: string;
  newPassword: string;
}

interface INewUser {
  username: string;
  ownerId: number;
  userRoleId: number;
  userType: string;
}
interface IGroupShort {
  group_id: string;
  name_es: string;
}

interface ISecondaryGroupShort {
  secondaryInvestigationGroup_id: string;
  name_es: string;
}

export const ManageProfile: FC = () => {
  let { token, staffId, isAdmin } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();

  const { pathname }: any = useLocation();
  let id: any = "";
  if (pathname.includes("perfil")) {
    id = staffId?.toString()!;
  } else {
    id = pathname.split("/")[2];
  }
  let userType: string = "";
  if (pathname.includes("service")) {
    userType = "service-staff";
  } else {
    userType = "investigator";
  }

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const {
    INVESTIGATORS,
    // RESEARCHLINES,
    INVESTROLE,
    USERROLE,
    USERS,
    GROUPS,
    newUsers,
    userSelectPUBLICATION,
    publicationsINVESTIGATOR,
    NEWPASSWORD,
    RESETPASSWORD,
  } = paths;

  const [isCreate, setIsCreate] = useState(false);
  const [isMyProfile, setIsMyProfile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //userForm
  const [userToEditId, setUserToEditId] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");

  const [userName, setUserName] = useState("");
  const [email_personal, setEmail] = useState("");
  const [image, setImage] = useState();
  const [telefono, setTelefono] = useState("");
  // const [researchLines, setResearchLines] = useState<IResearchLineShort[]>([]);
  // const [chosenResearchLines, setChosenResearchLines] = useState([]);
  const [emailPublico, setEmailPublico] = useState("");  
  const [aparecerTodos, setAparecerTodos] = useState("");
  const [info, setInfo] = useState('')
  const [edicionGrupo, setEdicionGrupo] = useState('')
  const [edicionUnidad, setEdicionUnidad] = useState('')
  const [userRoles, setUserRoles] = useState<IUserRole[]>([]);
  // const [staffRole, setStaffRole] = useState("");
  // const [grupoFuncional, setGrupoFuncional] = useState("");
  const [chosenUserRoleId, setChosenUserRoleId] = useState("");
  const [investigatorTypes, setInvestigatorTypes] = useState<
    IInvestigatorRole[]
  >([]);  
  const [groups, setGroups] = useState<IGroupShort[]>([]);
  const [chosenGroupId, setChosenGroupId] = useState("");
  const [secondaryInvestigationGroup, setSecondaryInvestigationGroup] = useState<ISecondaryGroupShort[]>([]);
  const [
    chosenSecondaryInvestigationGroupId,
    setChosenSecondaryInvestigationGroupId,
  ] = useState("");
  const [chosenUserTypeId, setChosenUserTypeId] = useState("");
  const [facebook, setFacebook] = useState("");
  const [orcid, setOrcid] = useState("");
  const [extension, setExtension] = useState("")
  const [twitter, setTwitter] = useState("");
  const [linkedIn, setLinkedIn] = useState("");
  const [webPersonal, setWebPersonal] = useState("");
  const [blueSky, setBlueSky] = useState("");
  const [bioEs, setBioEs] = useState("");
  const [bioEn, setBioEn] = useState("");
  const [formacion, setFormacion] = useState('')
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [selectedPublications, setSelectedPublications] = useState<
    IPublication[]
  >([]);
  const [displayPublications, setDisplayPublications] = useState<
    IPublication[]
  >([]);
  const [allDisplayPublications, setAllDisplayPublications] = useState<
    IPublication[]
  >([]);

  //change Password
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPass, setRepeatNewPass] = useState("");
  const [isPassChecked, setIsPassChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [passMessage, setPassMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  useEffect(() => {
    isMountedRef.current = true;
    checkIfCreate();
    // loadResearchLines();
    loadInvestigationRoles();
    loadInvestigationGroups();
    loadUserRole();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const checkIfCreate = () => {
    const { pathname }: any = history.location;
    if (pathname.includes("crear")) {
      setIsCreate(true);
    } else {
      loadInvestigator();
      if (pathname.includes("perfil")) {
        setIsLoading(true);
        setIsMyProfile(true);
        loadUserPublications();
      }
    }
  };

  
  const loadInvestigationGroups = async () => {
    try {
      let rawInvGroups = await getAll(GROUPS, source);

      if (isMountedRef.current) {
        filterGruops(rawInvGroups);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };

  const filterGruops = (rawGroups: any[]) => {
    let filteredGropus: IGroupShort[] = rawGroups.map(({ id, nameEs }) => ({
      group_id: id,
      name_es: nameEs,
    }));
    let filteredSecondaryInvestigationGropus: ISecondaryGroupShort[] = rawGroups.map(({ id, nameEs }) => ({
      secondaryInvestigationGroup_id: id,
      name_es: nameEs,
    }));
    setGroups(filteredGropus);
    setSecondaryInvestigationGroup(filteredSecondaryInvestigationGropus);
  };
  // const loadResearchLines = async () => {
  //   try {
  //     let rawInvGroups = await getAll(RESEARCHLINES, source);

  //     if (isMountedRef.current) {
  //       filterResearchLines(rawInvGroups);
  //     }
  //   } catch (error) {
  //     console.log("HTTP call cancelled");
  //     console.log(error);
  //   }
  // };

  // const filterResearchLines = (rawGroups: any[]) => {
  //   let filteredGropus: IResearchLineShort[] = rawGroups.map(({ id, tituloEs }) => ({
  //     researchLine_id: id,
  //     tituloEs: tituloEs,
  //   }));
  //   setResearchLines(filteredGropus);
  // };

  const loadInvestigationRoles = async () => {
    try {
      let roles = await getAll(INVESTROLE, source);

      if (isMountedRef.current) {
        filterInvestigatorRole(roles);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };

  const filterInvestigatorRole = (roles: any[]) => {
    let filteredInvestigatorRoles: IInvestigatorRole[] = roles.map(
      ({ id, name }) => ({
        staff_role_id: id,
        name,
      })
    );
    setInvestigatorTypes(filteredInvestigatorRoles);
  };

  const loadUserPublications = async () => {
    let publications = await getByInvestigator(
      publicationsINVESTIGATOR,
      staffId,
      source
    );    
    reorderPublications(publications);
    setIsLoading(false);
  };

  const chechEmail = (value: string) => {
    let validatedEmail = validateEmail(value);
    if (!validatedEmail) {
      setMessage("Formato de email no válido.");
    } else {
      setMessage("");
    }
  };

  //HANDLE PUBLICATIONS

  const reorderPublications = (publications: any[]) => {
    let newPublications: any[] = [];
    publications.map(
      ({
        id,
        title,
        date,
        journal,
        url,
        authors,
        volPag,
        staffId,
        staffPublications,
      }: 
      any) => {
        newPublications.push({
          id,
          title,
          date,
          journal,
          url,
          authors,
          volPag,
          staffId,
          selected: staffPublications[0]?.selected,
        });
      }
    );
    return filterSelectedPublications(newPublications);
  };

 const filterSelectedPublications = (publications: IPublication[]) => {
   const selectedPublications = publications.filter(
     ({ selected }: IPublication) => selected === true
   );

   setSelectedPublications(selectedPublications);

   const notSelectedPublications = publications.filter(
     ({ selected }: IPublication) => selected === false
   );

   setDisplayPublications(notSelectedPublications);
   setAllDisplayPublications(notSelectedPublications);
 };

  const createOREditInvestigatorForm = () => {
    let form: IInvestigator = isCreate
      ? {
          nombre,
          apellidos,
          email_personal,
          telefono,
          bioEs,
          bioEn,
          formacion,
          investigatorRoleId: chosenUserTypeId ? +chosenUserTypeId : null,
          investigationGroupId: +chosenGroupId! ? +chosenGroupId! : null,
          secondaryInvestigationGroupId: +chosenSecondaryInvestigationGroupId
            ? +chosenSecondaryInvestigationGroupId!
            : null,
          // staffRole,
          // grupoFuncional,
          linkedin: linkedIn,
          webPersonal: webPersonal,
          blueSky,
          twitter,
          facebook,
          orcid,
          extension,
          username: userName,
          password,
          info,
          edicionGrupo: edicionGrupo === "1" ? true : false,
          edicionUnidad: edicionUnidad === "1" ? true : false,
          userRoleId: +chosenUserRoleId,
          emailPublico: emailPublico === "1" ? true : false,
          aparecerTodos: aparecerTodos === "1" ? true : false,
        }
      : {
          nombre,
          apellidos,
          email_personal,
          telefono,
          bioEs,
          bioEn,
          formacion,
          // researchLineIds:
          //   chosenResearchLines.length > 0
          //     ? chosenResearchLines.map(
          //         (researchLine: IResearchLineShort) =>
          //           researchLine.researchLine_id
          //       )
          //     : null,

          investigatorRoleId: chosenUserTypeId ? +chosenUserTypeId : null,

          investigationGroupId: +chosenGroupId! ? +chosenGroupId! : null,
          secondaryInvestigationGroupId: +chosenSecondaryInvestigationGroupId
            ? +chosenSecondaryInvestigationGroupId!
            : null,
          // staffRole,
          // grupoFuncional,
          linkedin: linkedIn,
          webPersonal: webPersonal,
          blueSky,
          twitter,
          facebook,
          orcid,
          extension,
          emailPublico: emailPublico === "1" ? 1 : 0,
          aparecerTodos: aparecerTodos === "1" ? 1 : 0,
          info,
          edicionGrupo: edicionGrupo === "1" ? true : false,
          edicionUnidad: edicionUnidad === "1" ? true : false,
        };
    return form;
  };

  const editUserForm = (ownerId: number) => {
    let userForm: INewUser = {
      username: userName,
      ownerId,
      userType,
      userRoleId: +chosenUserRoleId,
    };
    return userForm;
  };

  const handleSubmit = () => {
    let question: string = "";
    isCreate
      ? (question = `¿Quieres crear un nuevo usuario?`)
      : (question = " ¿Quieres actualizar tu perfil?");
    Swal.fire({
      icon: "question",
      text: question,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "No",
      customClass: {
        confirmButton: "buttonSwalConfirm",
      },
    }).then(({ isConfirmed }) => {
      if (isConfirmed && isCreate) {
        handleNewUser();
      } else if (isConfirmed && !isCreate) {
        handleConfirmation();
      }
    });
  };

  const loadUserRole = async () => {
    try {
      let roles = await getAll(USERROLE, source);

      if (isMountedRef.current) {
        filterUserRole(roles);
      } else setAllowedEdit(true);
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };

  const filterUserRole = (roles: any[]) => {
    let filteredUserRoles: IUserRole[] = roles.map(({ id, name }) => ({
      user_role_id: id,
      name,
    }));
    setUserRoles(filteredUserRoles);
  };

  const checkPassword = (value: string) => {
    let repeatPassword = value;
    if (password !== repeatPassword) {
      setMessage("Las contraseñas no coinciden.");
    } else {
      setMessage("");
    }
  };

  const handleNewUser = () => {
    if (!nombre || !apellidos || !userName) {
      Swal.fire({
        icon: "error",
        text: "Los campos con * son obligatorios. Por favor, completa el formulario.",
        customClass: {
          cancelButton: "buttonClass",
        },
      });
    } else {
      let form = createOREditInvestigatorForm();
      create(newUsers, form, source)
        .then(async (userCreated) => {
          const newlyCreatedStaffId = userCreated?.staff?.id;
          Swal.fire({
            icon: "success",
            text: `Usuario creado correctamente.`,
          });
          if (typeof image !== "string") {
            const formData = new FormData();
            formData.append("image", image!);
            await saveFile(
              INVESTIGATORS,
              newlyCreatedStaffId,
              "image",
              formData,
              source
            );
          }  
        })

        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            text: "Ha habido un error, por favor intente de nuevo más tarde.",
          });
        });
    }
  };

  // EDIT MY PROFILE
  const loadInvestigator = async () => {
    try {
      // let allResearchLines = await getAll(RESEARCHLINES, source);
      const {
        nombre,
        apellidos,
        email_personal,
        telefono,
        bioEs,
        bioEn,
        formacion,
        // researchLines,
        investigatorRole,
        // staffRole,
        // grupoFuncional,
        linkedin,
        webPersonal,
        blueSky,
        twitter,
        facebook,
        investigationGroup,
        secondaryInvestigationGroup,
        orcid,
        extension,
        image,
        emailPublico,
        aparecerTodos,
        info,
        edicionGrupo,
        edicionUnidad,
        user,
      } = await getById(INVESTIGATORS, id, source);
      let a = await getById(INVESTIGATORS, id, source);
      if (isMountedRef.current) {
        setNombre(nombre);
        setApellidos(apellidos);
        setEmail(email_personal);
        setTelefono(telefono);
        setBioEs(bioEs);
        setBioEn(bioEn);
        setFormacion(formacion)
      //  const selectedResearchLineIds = researchLines.map((a: any) => a.id);
      //  const availableResearchLines = allResearchLines.filter(
      //    (a: any) => !selectedResearchLineIds.includes(a.id)
      //  );
investigationGroup?.id !== "NULL"
  ? setChosenGroupId(investigationGroup?.id)
  : setChosenGroupId("");
  secondaryInvestigationGroup?.id !== "NULL"
    ? setChosenSecondaryInvestigationGroupId(secondaryInvestigationGroup?.id)
    : setChosenSecondaryInvestigationGroupId("");
      //  setResearchLines(availableResearchLines);
      // const normalizedResearchLines = researchLines.map((line: any) => ({
      //   researchLine_id: line.id, // 👈 usamos researchLine_id como espera el resto del código
      //   tituloEs: line.tituloEs,
      // }));
      // setChosenResearchLines(normalizedResearchLines);

        setChosenUserTypeId(investigatorRole?.id);
        setLinkedIn(linkedin);
        setWebPersonal(webPersonal);
        setBlueSky(blueSky);
        setTwitter(twitter);
        setFacebook(facebook);
        setOrcid(orcid);
        setExtension(extension)
        // setStaffRole(staffRole);
        // setGrupoFuncional(grupoFuncional);
        setImage(image);
        setEmailPublico(emailPublico === true ? "1" : "0");
        setAparecerTodos(aparecerTodos === true ? "1" : "0");
        setInfo(info);
        setEdicionGrupo(edicionGrupo === true ? "1" : "0");
        setEdicionUnidad(edicionUnidad === true ? "1" : "0");
        setUserName(user?.username);
        setUserToEditId(user?.id);
        setChosenUserRoleId(user?.userRole?.id);
        setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };
// const addItem = (item: string, type: string) => {
//   const parsedItem: IResearchLineShort = (() => {
//     const rawItem = JSON.parse(item);
//     return {
//       researchLine_id: rawItem.researchLine_id ?? rawItem.id, // <- asegura consistencia
//       tituloEs: rawItem.tituloEs,
//     };
//   })();


//   if (type === "researchLines") {
//     setChosenResearchLines((state) =>
//       produce(state, (draftState: IResearchLineShort[]) => {
//         if (draftState.length < 2) {
//           // ✅ Solo permite agregar si hay menos de 2 lineas
//           draftState.push(parsedItem);

//           // Quitar la linea seleccionado de la lista de opciones
//           setResearchLines((state) =>
//             produce(state, (draftState: IResearchLineShort[]) => {
//               const index = draftState.findIndex(
//                 ({ researchLine_id }) =>
//                   researchLine_id === parsedItem.researchLine_id
//               );
//               if (index !== -1) {
//                 draftState.splice(index, 1);
//               }
//             })
//           );
//         } else {
//           alert("Solo puedes seleccionar un máximo de 2 lineas de investigación."); // ✅ Muestra alerta si intenta agregar más de 2
//         }
//       })
//     );
//   }
// };


//   const removeItem = (item: any, type: any) => {
//     if (!allowedEdit) return;

//     if (type === "researchLines") {
//       setChosenResearchLines((state) =>
//         produce(state, (draftState) => {
//           const index = draftState.findIndex(
//             ({ researchLine_id }) => researchLine_id === item.researchLine_id
//           );
//           console.log(item.id, );
          
//           if (index !== -1) {
//             draftState.splice(index, 1); // ✅ Solo elimina la linea seleccionado
//           }
//         })
//       );

//       setResearchLines((state) =>
//         produce(state, (draftState) => {
//           if (
//             !draftState.some(
//               ({ researchLine_id }) => researchLine_id === item.researchLine_id
//             )
//           ) {
//             draftState.push(item); // ✅ Solo lo agrega si no está en la lista de lineas
//           }
//         })
//       );
//     }
//   };
  const handleConfirmation = async () => {
    if (!nombre || !apellidos || !userName) {
      Swal.fire({
        icon: "error",
        text: "Los campos con * son obligatorios. Por favor, completa el formulario.",
        customClass: {
          cancelButton: "buttonClass",
        },
      });
    } else {
      let form = createOREditInvestigatorForm();
      update(INVESTIGATORS, id, form, token).then(() => {
        let userForm = editUserForm(+id);
        update(USERS, +userToEditId, userForm, token)
          .then(async () => {
            Swal.fire({
              icon: "success",
              text: `Perfil actualizado correctamente.`,
            });
            if (typeof image !== "string") {
              const formData = new FormData();
              formData.append("image", image!);
              await saveFile(INVESTIGATORS, id, "image", formData, source);
            }
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              text: "Ha habido un error, por favor intente de nuevo más tarde.",
            });
          });
      });
    }
  };

  const handleDelete = () => {
    Swal.fire({
      icon: "question",
      text: `¿Quieres borrar este usuario?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed &&
        Delete(INVESTIGATORS, id, source)
          .then(({ id }) => {
            Swal.fire({
              icon: "success",
              text: `Usuario borrado correctamente.`,
            });
            history.push(ROUTES.Users.all);
            setIsCreate(false);
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: "error",
              text: "Ha habido un error, por favor intente de nuevo más tarde.",
            });
          });
    });
  };

  const editDeleteButtons = () => {
    if (!isCreate && !isMyProfile) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-success ml-1"
            onClick={handleResetPassword}
          >
            <FontAwesomeIcon icon={faRedo} />
          </button>
          <button className="smallBtn btn-danger ml-1" onClick={handleDelete}>
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    } else if (!isCreate && isMyProfile) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
        </>
      );
    } else {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Usuario
        </button>
      );
    }
  };

  //PUBLICATIONS

 const searchBar = (value: string) => {
   if (!value.trim()) {
     setDisplayPublications(allDisplayPublications);
     return;
   }

   const filtered = allDisplayPublications.filter(({ title }: any) =>
     title.toLowerCase().includes(value.toLowerCase())
   );

   setDisplayPublications(filtered);
 };
  const changeIcon = (isSelected: any) => {
    return !isSelected ? estrella : estrellaAzul;
  };

const changeNotSelected = (index: number) => {
  const newPublications = [...displayPublications];

  const selected = !Boolean(newPublications[index].selected);

  newPublications[index].selected = selected;

  setDisplayPublications(newPublications);

  saveSinglePublication(newPublications[index].id, selected);
};
const changeSelected = (index: number) => {
  const newSelected = [...selectedPublications];

  const selected = !Boolean(newSelected[index].selected);

  newSelected[index].selected = selected;

  setSelectedPublications(newSelected);

  saveSinglePublication(newSelected[index].id, selected);
};
const saveSinglePublication = (
  publicationId: number,
  selected: boolean
) => {
  patch(
    `staff/${id}/publication/${publicationId}`,
    { selected },
    source
  )
    .then(() => {
      Swal.fire({
        icon: "success",
        text: "Publicación actualizada correctamente.",
      });
    })
    .catch(() => {
      Swal.fire({
        icon: "error",
        text: SwalError,
      });
    });
};

  //HANDLE SELECTED PUBLICATIONS

  // const handleSubmitPublications = () => {
  //   const newPublications = buildSelectedPublications();
  //   const count = countSelected(newPublications);
  //   if (count > 10) {
  //     Swal.fire({
  //       icon: "error",
  //       text: "Se pueden seleccionar un máximo de 10 publicaciones",
  //       customClass: {
  //         cancelButton: "buttonClass",
  //       },
  //     });
  //   } else {
  //     create(
  //       `${userSelectPUBLICATION}/${id}/publication/`,
  //       newPublications,
  //       source
  //     )
  //       .then(() => {
  //         Swal.fire({
  //           icon: "success",
  //           text: `Publicaciones seleccionadas correctamente.`,
  //         });
         
  //         isMountedRef.current && setIsCreate(false);
  //       })
  //       .catch(() => {
  //         Swal.fire({
  //           icon: "error",
  //           text: SwalError,
  //         });
  //       });
  //   }
  // };

  // const buildSelectedPublications = () => {
  //   let newSelectedPublications: any[] = [];
  //   let completePublications = [
  //     ...selectedPublications,
  //     ...displayPublications,
  //   ];
  //   completePublications.map(({ id: publicationId, selected }: any) =>
  //     newSelectedPublications.push({
  //       staffId,
  //       publicationId,
  //       selected,
  //     })
  //   );
  //   return newSelectedPublications;
  // };

  const countSelected = (totalPublications: any[]) => {
    const count = totalPublications.filter(
      ({ selected }) => selected === true
    ).length;
    return count;
  };

  //CHANGE PASSWORD

  const checkNewPassword = (value: string) => {
    let repeatNewPass = value;
    if (newPassword !== repeatNewPass) {
      setPassMessage("Las contraseñas no coinciden.");
      setIsPassChecked(false);
    } else {
      setPassMessage("");
      setIsPassChecked(true);
    }
  };

  //HANDLE CAHNGE PASSWORD

  const handleSubmitNewPassword = () => {
    if (!oldPassword || !newPassword || !repeatNewPass) {
      setPassMessage(requiredInputs);
      setTimeout(() => setPassMessage(""), 4000);
      return;
    }
    const newPasswordForm: INewPassword = {
      oldPassword,
      newPassword,
    };
    Swal.fire({
      icon: "question",
      text: `¿Quieres cambiar tu contraseña?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleNewPasswordConfirmation(newPasswordForm);
    });
  };

  const handleNewPasswordConfirmation = (newPasswordForm: INewPassword) => {
    create(NEWPASSWORD, newPasswordForm, source)
      .then(() => {
        Swal.fire({
          icon: "success",
          text: `Contraseña cambiada correctamente.`,
        });
        isMountedRef.current && setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  //HANDLE RESET PASSWORD

  const handleResetPassword = () => {
    Swal.fire({
      icon: "question",
      text: `¿Quieres resetear la contraseña de este usuario?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed &&
        resetPass(RESETPASSWORD, +userToEditId, source)
          .then(() => {
            const year = moment(new Date()).locale("es").format("YYYY");
            Swal.fire({
              icon: "success",
              text: `Contraseña reseteada a cabimer${year}`,
            });
            isMountedRef.current && setIsCreate(false);
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              text: SwalError,
            });
          });
    });
  };

  return (
    <div className="centerPage">
      <div className="container-fluid ">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Perfil</h3>
            </div>
            <div>{editDeleteButtons()}</div>
          </div>
        </div>
      </div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4">
        <div className="form-row mt-2  d-flex flex-start">
          {!isCreate ? (
            <div style={{ width: "50%", paddingLeft: "10%" }}>
              <FileUploader handleFile={setImage} image={image} />
            </div>
          ) : (
            <div style={{ width: "50%", paddingLeft: "10%" }}>
              <FileUploader handleFile={setImage} image={image} />
            </div>
          )}

          <div className="col-6   justify-content-center">
            <small id="label">Nombre*</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Nombre"
              value={nombre}
              onChange={({ target: { value } }) => {
                setNombre(value);
              }}
            />
            <div className=" mt-2">
              {" "}
              <small>Apellidos*</small>
              <input
                type="text"
                className="form-control"
                // placeholder="Primer Apellido"
                value={apellidos}
                onChange={({ target: { value } }) => {
                  setApellidos(value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="form-row mt-3">
          <h5>Datos de usuario</h5>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>Nombre de Usuario*</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Nombre de usuario"
              value={userName}
              onChange={({ target: { value } }) => {
                setUserName(value);
              }}
            />
          </div>
          <div className="col">
            <small>Email*</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Email"
              value={email_personal}
              onChange={({ target: { value } }) => {
                setEmail(value);
                chechEmail(value);
              }}
            />
          </div>
          <div className="col">
            <span>¿Email público?</span>
            <select
              className="form-control input"
              value={emailPublico}
              onChange={({ target: { value } }) => {
                setEmailPublico(value);
              }}
            >
              <option value={0}>Email oculto</option>
              <option value={1}>Email público</option>
            </select>
          </div>

          <div className="col">
            <small>Teléfono*</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Teléfono"
              value={telefono ? telefono : ""}
              onChange={({ target: { value } }) => {
                setTelefono(value);
              }}
            />
          </div>
        </div>

        {isCreate && (
          <div className="form-row">
            <div className="col">
              <small id="label">Contraseña*</small>
              <input
                type="password"
                className="form-control"
                // placeholder="Contraseña"
                disabled={!isCreate}
                value={password}
                onChange={({ target: { value } }) => {
                  setPassword(value);
                }}
              />
            </div>
            <div className="col">
              <small>Repetir contraseña*</small>
              <input
                type="password"
                className="form-control"
                // placeholder="Repetir contraseña"
                disabled={!isCreate}
                value={repeatPassword}
                onChange={({ target: { value } }) => {
                  setRepeatPassword(value);
                  checkPassword(value);
                }}
              />
            </div>
          </div>
        )}
        <div className="form-row mt-3">
          {" "}
          <div className="col">
            <small>Tipo de investigador*</small>
            <select
              className="form-control input"
              value={chosenUserTypeId}
              onChange={({ target: { value } }) => {
                setChosenUserTypeId(value);
              }}
            >
              <>
                <option value="">Tipo de Investigador</option>
                {investigatorTypes?.map(({ staff_role_id, name }) => (
                  <option key={staff_role_id} value={staff_role_id}>
                    {name}
                  </option>
                ))}
              </>
            </select>
          </div>
          <div className="col">
            <span>¿Aparecer en la web?</span>
            <select
              className="form-control input"
              value={aparecerTodos}
              onChange={({ target: { value } }) => {
                setAparecerTodos(value);
              }}
            >
              <option value="">Seleccione un valor</option>
              <option value={0}>No</option>
              <option value={1}>Si</option>
            </select>
          </div>
          <div className="col">
            <small>Extensión</small>
            <input
              type="text"
              className="form-control"
              placeholder="Extensión  "
              value={extension ? extension : ""}
              onChange={({ target: { value } }) => {
                setExtension(value);
              }}
            />
          </div>
        </div>
        {(isCreate || isAdmin) && (
          <div className="form-row mt-3">
            {" "}
            <div className="col">
              <small>Información del usuario</small>
              <select
                className="form-control input"
                value={info}
                onChange={({ target: { value } }) => {
                  setInfo(value);
                }}
              >
                <option value="">Información</option>
                <option value="Basica">Básica</option>
                <option value="Web_personal">Con páginas personales</option>
                <option value="Completa">Completa</option>{" "}
              </select>
            </div>
            <div className="col">
              <span>¿Permiso de edición de grupos?</span>
              <select
                className="form-control input"
                value={edicionGrupo}
                onChange={({ target: { value } }) => {
                  setEdicionGrupo(value);
                }}
              >
                <option value={0}>No</option>
                <option value={1}>Si</option>
              </select>
            </div>
            <div className="col">
              <span>¿Permiso de edición de unidades?</span>
              <select
                className="form-control input"
                value={edicionUnidad}
                onChange={({ target: { value } }) => {
                  setEdicionUnidad(value);
                }}
              >
                <option value={0}>No</option>
                <option value={1}>Si</option>
              </select>
            </div>
          </div>
        )}

        {(isCreate || isAdmin) && (
          <div className="form-row mt-3">
            <div className="col">
              <small>Grupo</small>
              <select
                className="form-control input"
                value={chosenGroupId!}
                onChange={({ target: { value } }) => {
                  setChosenGroupId(value);
                }}
              >
                <option value="none">Grupo</option>
                <option value="">No Procede</option>
                {groups?.map(({ group_id, name_es }) => (
                  <option key={group_id} value={group_id}>
                    {name_es}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <small>Grupo secundario</small>
              <select
                className="form-control input"
                value={chosenSecondaryInvestigationGroupId!}
                onChange={({ target: { value } }) => {
                  setChosenSecondaryInvestigationGroupId(value);
                }}
              >
                <option value="none">Grupo</option>
                <option value="">No Procede</option>
                {secondaryInvestigationGroup?.map(
                  ({ secondaryInvestigationGroup_id, name_es }) => (
                    <option
                      key={secondaryInvestigationGroup_id}
                      value={secondaryInvestigationGroup_id}
                    >
                      {name_es}
                    </option>
                  )
                )}
              </select>
            </div>
            {/* 
            <div className="col">
              <small>Categoría de usuario*</small>
              <select
                className="form-control input"
                value={staffRole}
                onChange={({ target: { value } }) => {
                  setStaffRole(value);
                }}
              >
                <option value="">Categoría de usuario</option>
                <option value="administration">Administración</option>
                <option value="technical">Técnico</option>{" "}
                <option value="investigation">Investigación</option>
              </select>
            </div> */}
            {/* <div className="col">
              <small>Grupo funcional*</small>
              <select
                className="form-control input"
                value={grupoFuncional}
                onChange={({ target: { value } }) => {
                  setGrupoFuncional(value);
                }}
              >
                <option value="leadership">Equipo directivo</option>
                <option value="research_staff">
                  Personal investigador
                </option>{" "}
                <option value="doctoral_research">
                  Investigadores pre-doctorales
                </option>
                <option value="management">Gestion y apoyo tecnico</option>
              </select>
            </div> */}

            <div className="col">
              <small>Rol de usuario*</small>
              <select
                className="form-control input"
                value={chosenUserRoleId}
                onChange={({ target: { value } }) => {
                  setChosenUserRoleId(value);
                }}
              >
                <option>Rol de usuario</option>
                {userRoles?.map(({ user_role_id, name }) => (
                  <option key={user_role_id} value={user_role_id}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {(isCreate || isAdmin) && (
          <div className="form-row mt-3">
            {/* <div className="col">
              <small>Rol de usuario*</small>
              <select
                className="form-control input"
                value={chosenUserRoleId}
                onChange={({ target: { value } }) => {
                  setChosenUserRoleId(value);
                }}
              >
                <option>Rol de usuario</option>
                {userRoles?.map(({ user_role_id, name }) => (
                  <option key={user_role_id} value={user_role_id}>
                    {name}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
        )}

        <div className="form-row mt-4">
          {/* <div className="col">
            <span>Linea de investigación</span>
            <select
              className="form-control input"
              value={""}
              onChange={({ target }: any) =>
                addItem(target.value, "researchLines")
              }
            >
              <option value={""}>Seleccionar Linea de investigación</option>
              {researchLines?.map((researchLine: any) => (
                <option
                  key={researchLine.researchLine_id}
                  value={JSON.stringify(researchLine)}
                >
                  {researchLine.tituloEs}
                </option>
              ))}
            </select>
            {console.log(chosenResearchLines, "ch")}
            {chosenResearchLines?.map((researchLine: any) => (
              <span
                key={researchLine.researchLine_id}
                style={{ cursor: "pointer" }}
                className="badge badge-info badge-blue-color mr-1 mt-3"
                onClick={() => removeItem(researchLine, "researchLines")}
              >
                {researchLine.tituloEs} X
              </span>
            ))}
          </div> */}
        </div>
        {info === "Completa" || info === "Web_personal" ? (
          <>
            {" "}
            <div className="form-row mt-3">
              <h5>Enlaces personales</h5>
            </div>
            <div className="form-row mt-3">
              <div className="col">
                <small>LinkedIn</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej:https://www.linkedin.com/perfil"
                  value={linkedIn ? linkedIn : ""}
                  onChange={({ target: { value } }) => {
                    setLinkedIn(value);
                  }}
                />
              </div>
              <div className="col">
                <small>X</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej:https://x.com/perfil"
                  value={twitter ? twitter : ""}
                  onChange={({ target: { value } }) => {
                    setTwitter(value);
                  }}
                />
              </div>
            </div>
            <div className="form-row mt-3">
              <div className="col">
                <small>Facebook</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej:https://www.facebook.com/perfil"
                  value={facebook ? facebook : ""}
                  onChange={({ target: { value } }) => {
                    setFacebook(value);
                  }}
                />
              </div>
              <div className="col">
                <small>Orcid</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Solo el código Orcid   "
                  value={orcid ? orcid : ""}
                  onChange={({ target: { value } }) => {
                    setOrcid(value);
                  }}
                />
              </div>
            </div>
            <div className="form-row mt-3">
              <div className="col">
                <small>BlueSky</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej: https://bsky.app/profile/profile"
                  value={blueSky ? blueSky : ""}
                  onChange={({ target: { value } }) => {
                    setBlueSky(value);
                  }}
                />
              </div>
              <div className="col">
                <small>Web Personal</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  value={webPersonal ? webPersonal : ""}
                  onChange={({ target: { value } }) => {
                    setWebPersonal(value);
                  }}
                />
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      {info === "Completa" && (
        <div>
          {" "}
          {(isCreate || allowedEdit) && (
            <div className="mt-4">
              <div className="col">
                <small>*Biografía en español</small>
                <CKEditor
                  initData={bioEs}
                  config={editorConfig}
                  onChange={({ editor }: { editor: any }) =>
                    setBioEs(editor.getData())
                  }
                />
              </div>
              <div className="col mt-4">
                <small>*Biografía en inglés</small>
                <CKEditor
                  initData={bioEn && bioEn}
                  config={editorConfig}
                  onChange={({ editor }: { editor: any }) =>
                    setBioEn(editor.getData())
                  }
                />
              </div>
            </div>
          )}
          {(isCreate || allowedEdit) && (
            <div className=" mt-4">
              <div className="col">
                <small>Formación académica</small>
                <CKEditor
                  initData={formacion}
                  config={editorConfig}
                  onChange={({ editor }: { editor: any }) =>
                    setFormacion(editor.getData())
                  }
                />
              </div>
            </div>
          )}
        </div>
      )}

      <div className=" mt-4">
        {isMyProfile && (
          <div className="col">
            <button className="baseBtn" onClick={() => setIsModalOpen(true)}>
              Cambiar Contraseña
            </button>
          </div>
        )}
      </div>

      {info === "Completa" && (
        <>
          {" "}
          {!isCreate && isMyProfile && (
            <div className="row mt-4">
              <div className="col-12 ">
                <div className="col d-flex justify-content-between">
                  <h5>Publicaciones seleccionadas</h5>
                </div>
                <table className="table table-hover mt-4">
                  <tbody>
                    {selectedPublications?.map(
                      (
                        { id, title, authors, date, selected }: IPublication,
                        index
                      ) => (
                        <tr key={index} className="pointer">
                          <td>
                            <div className="d-flex justify-content-between">
                              <h6>{parse(title)}</h6>
                              <img
                                style={{ width: "2%" }}
                                src={changeIcon(selected)}
                                alt=""
                                onClick={() => changeSelected(index)}
                              />
                            </div>

                            <p>
                              {authors} {","}{" "}
                              {moment(date).locale("es").format("YYYY")}
                            </p>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                {isLoading && isMyProfile && (
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border mt-5" role="status" />
                  </div>
                )}

                {!selectedPublications.length && !isLoading && (
                  <div className="d-flex justify-content-center mb-3">
                    <h5>-No hay publicaciones seleccionadas-</h5>
                  </div>
                )}
              </div>
            </div>
          )}
          {!isCreate && isMyProfile && (
            <div className="row mt-4">
              <Form.Group as={Col}>
                <InputGroup className="shadow">
                  <InputGroup.Prepend>
                    <InputGroup.Text className="inputGroup ">
                      <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="text"
                    placeholder="Buscar..."
                    className="form-control"
                    onChange={({ target: { value } }) => searchBar(value)}
                  />
                </InputGroup>
              </Form.Group>
            </div>
          )}
          {!isCreate && isMyProfile && (
            <div className="row mt-3">
              <div className="col-12 ">
                <h5>Publicaciones</h5>
           
                <table className="table table-hover">
                  <tbody>
                    {displayPublications?.map(
                      (
                        { id, title, authors, date, selected }: IPublication,
                        index
                      ) => (
                        <tr key={index} className="pointer">
                          <td>
                            <div className="d-flex justify-content-between">
                              <h6>{parse(title)}</h6>
                              <img
                                style={{ width: "2%" }}
                                src={changeIcon(selected)}
                                alt=""
                                onClick={() => changeNotSelected(index)}
                              />
                            </div>
                            <p>
                              {authors} {","}{" "}
                              {moment(date).locale("es").format("YYYY")}
                            </p>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                {isLoading && (
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border mt-5" role="status" />
                  </div>
                )}

                {!displayPublications.length && !isLoading && (
                  <div className="d-flex justify-content-center mb-3">
                    <h5>-No hay publicaciones-</h5>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {/* //Modal para cambiar contraseña */}
      <Modal centered show={isModalOpen} onHide={() => setIsModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Actualiza tu contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center text-danger">
                <span>{passMessage}</span>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <input
                  className="form-control"
                  type="password"
                  placeholder="*Contraseña Actual"
                  value={oldPassword}
                  onChange={({ target: { value } }) => {
                    setOldPassword(value);
                  }}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <input
                  className="form-control"
                  type="password"
                  placeholder="*Nueva Contraseña"
                  value={newPassword}
                  onChange={({ target: { value } }) => {
                    setNewPassword(value);
                  }}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <input
                  className="form-control"
                  type="password"
                  placeholder="*Repetir Contraseña"
                  value={repeatNewPass}
                  onChange={({ target: { value } }) => {
                    setRepeatNewPass(value);
                    checkNewPassword(value);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
            Cerrar
          </Button>
          <Button
            variant="primary"
            disabled={!isPassChecked}
            onClick={handleSubmitNewPassword}
          >
            Guardar Cambio
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
